module.exports = __webpack_public_path__ + "static/media/orinocco61.f73146a8.jpg";